export default __webpack_public_path__ + "static/media/quartercircle-circumference.874fecd8.svg";